import React, {useMemo} from "react";

import {useOutletContext} from "react-router-dom";
import Social from "pages/Social";
import Internal from "pages/Internal";
import LandingPage from "pages/LandingPage";
import Partners from "pages/Partners";
import Livestream from "pages/Livestream";
import Email from "pages/Email";
import Print from "pages/Print";
import Video from "pages/Video";
import Events from "pages/Events";
import Releases from "pages/Releases";
import Webinar from "pages/Webinar";
import Ads from "pages/Ads";

const COMPONENT_MAPPING = {
  social: Social,
  internal: Internal,
  landingpage: LandingPage,
  partners: Partners,
  livestream: Livestream,
  webinar: Webinar,
  email: Email,
  print: Print,
  video: Video,
  events: Events,
  releases: Releases,
  ads: Ads,
};

const Scene = () => {
  // App loads the scene once. A page remount must not replace user edits.
  const {sceneData, isSceneLoaded} = useOutletContext();

  const Component = useMemo(() => {
    return COMPONENT_MAPPING[sceneData?.channel?.value] || (() => null);
  }, [sceneData?.channel?.value]);

  if (!isSceneLoaded) return <div>{"Loading..."}</div>;

  return <Component />;
};

export default Scene;
